import React from 'react';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import TableHeader from 'grommet/components/TableHeader';

const TableSample = ({iterator, dataNames}) => {
    let labelsName = []
    if (!dataNames) {
        iterator.forEach((input, index)=> {
            labelsName.push(`variable ${index + 1}`)
        })
    } else {
        labelsName = dataNames
    }
    //iterator[0] will dictate number of rows. Though some rows might have more data. In general, no nulls are acceptable hence all rows should have euqal number of items
    return (<Table scrollable={false} selectable={true} responsive={false}>
                    <TableHeader labels={labelsName}/>
                    <tbody>
                        {iterator[0].map((input, index)=> {
                            if (index >=1000) return;
                            return (
                            <TableRow>
                                {iterator.map((input2)=> {
                                    return (
                                        <td>{input2[index]}</td>
                                    )
                                })}
                            </TableRow>
                            )
                        })}
                    </tbody>
                </Table>)
}
export default TableSample;


// WEBPACK FOOTER //
// ./src/samples/data/tablesample.js